export default __webpack_public_path__ + "static/media/nifco_logo_no_tag.9896e0c2.png";